var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-breadcrumb-item',[(_vm.levelList.length<=1)?_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.levelList[0].meta.title))]):_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.levelList[_vm.levelList.length-2].meta.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }